<template>
  <CheckboxField :rules="rules" class="fs-sm">
    <i18n-t keypath="form.field.terms.label">
      <template #dataAgreement>
        <a href="/docs/6/">{{ $t("form.field.terms.dataAgreement") }}</a>
      </template>
      <template #privacyPolicy>
        <a href="/docs/2/">{{ $t("form.field.terms.privacyPolicy") }}</a>
      </template>
    </i18n-t>
  </CheckboxField>
</template>

<script lang="ts">
type TermsFieldProps = Omit<CheckboxFieldProps, "rules">;
type TermsFieldEvents = CheckboxFieldEvents;
</script>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { boolean } from "yup";
import CheckboxField, {
  CheckboxFieldEvents,
  CheckboxFieldProps,
} from "./CheckboxField.vue";

const { t } = useI18n();

withDefaults(defineProps<TermsFieldProps>(), {
  name: "terms",
  value: true,
});
defineEmits<TermsFieldEvents>();

const rules = boolean()
  .oneOf([true], t("form.field.terms.invalid.required"))
  .required(t("form.field.terms.invalid.required"));
</script>
